/**
 * Route for `deterministic-ctv-capi-s2s-for-ctv-conversions`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DeterministicCtvCapiS2sForCtvConversionsPage } from "../features/deterministic-ctv-capi-s2s-for-ctv-conversions/DeterministicCtvCapiS2sForCtvConversionsPage";

export const deterministicCtvCapiS2sForCtvConversionsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/deterministic-ctv-capi-s2s-for-ctv-conversions",
	component: DeterministicCtvCapiS2sForCtvConversionsPage,
});

export default deterministicCtvCapiS2sForCtvConversionsRoute;
